
import PaginationV2 from '@/components/ui/Pagination-V2.vue';
import numberHelper from '@/helper/number.helper';
import { defineComponent, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  BooleanTypes,
  constants,
  IsUserSearchEventAt,
} from '../../config/constant.config';
import dateTimeHelper from '../../helper/datetime.helper';
import swal from '../../helper/swal.helper';
import CrudModel from '../../models/partnersNotice.model';
import { ApiService } from '../../services/backend-api/api.services';

export default defineComponent({
  name: 'PartnersJoinList',
  props: {},
  components: {
    PaginationV2,
  },
  setup: () => {
    const router = useRouter();
    const route = useRoute();
    const notices = ref<Array<any>>([]);
    const apiService = new ApiService();
    const loading = ref(false);
    const userSearchEventFlag = ref<IsUserSearchEventAt>(IsUserSearchEventAt.N);
    const filter = ref({
      show_yn: '',
    });
    type filterKeyType = 'show_yn';
    const perpage = constants().DEFAULT_PERPAGE;

    const orderOptions = ref([['create_at', 'desc']]);
    const filterConditions = ref<Array<any>>([]);

    onMounted(async () => {
      await searchHandler();
    });
    const updateData = (items: Array<any>) => {
      loading.value = false;
      notices.value = items;
    };
    const isLoading = (value: boolean) => {
      loading.value = value;
    };

    const addRecord = () => {
      router.push({
        path: '/partners-notice/add',
        query: route.query,
      });
    };
    const editRecord = (id: string) => {
      router.push({
        path: `/partners-notice/edit/${id}`,
        query: route.query,
      });
    };

    const deleteRecord = (id: any) => {
      swal.simpleDeleteConfirm(async () => {
        await CrudModel.delete(id);
        const response = await CrudModel.getAll();
        notices.value = response.items;
      });
    };

    async function searchHandler() {
      if (userSearchEventFlag.value === IsUserSearchEventAt.Y) {
        route.query.page = '1';
      }
      filterConditions.value = [];

      setSearchFilterCondition('show_yn');
    }

    /**
     * 데이터 검색 조건 셋팅
     * @param filterKey
     * @param replaceFilterValue
     */
    function setSearchFilterCondition(
      filterKey: filterKeyType,
      replaceFilterValue?: string,
    ): void {
      if (filter.value[filterKey].trim() || replaceFilterValue) {
        filterConditions.value.push([
          [filterKey],
          replaceFilterValue ?? filter.value[filterKey],
        ]);
      } else if (
        // 페이지가 새로고침되었을 때 또는 뒤로가기로 왔을 때 url에 검색 관련 쿼리스트링이 있으면, 검색 조건에 추가 합니다.
        ((!filter.value[filterKey].trim() && route.query[filterKey]?.length) ||
          replaceFilterValue) &&
        userSearchEventFlag.value === IsUserSearchEventAt.N
      ) {
        filterConditions.value.push([
          [filterKey],
          replaceFilterValue ?? route.query[filterKey],
        ]);
        filter.value[filterKey] =
          replaceFilterValue ?? `${route.query[filterKey]}`;
      }
    }

    /**
     * Reset 버튼을 클릭했을 때 검색 조건을 초기화 합니다.
     */
    async function resetFilter() {
      filter.value.show_yn = '';

      userSearchEventFlag.value = IsUserSearchEventAt.Y;
      await searchHandler();
    }

    return {
      notices,
      addRecord,
      editRecord,
      deleteRecord,
      dateTimeHelper,
      numberHelper,
      loading,
      filter,
      orderOptions,
      filterConditions,
      updateData,
      isLoading,
      perpage,
      CrudModel,
      searchHandler,
      resetFilter,
      userSearchEventFlag,
      BooleanTypes,
      IsUserSearchEventAt,
    };
  },
});
